/**
 * Adding a '_WxH' suffix to the filename of an image hosted on Shopify's CDN returns a
 * scaled image which fits within the specified bounds, maintaining its original aspect ratio.
 * This function appends the suffix to the filename in the URL.
 * Default size for this function is 300px by 300px
 * More documentation: https://shopify.dev/docs/themes/liquid/reference/filters/url-filters#img_url
 */

export const scaleShopifyImageUrl = (
  url: string = "",
  { width, height }: { width: number; height: number } = {
    width: 300,
    height: 300,
  },
): string => {
  const extensionRegex = /\.[^/.]+$/
  return url.replace(
    extensionRegex,
    (extension) => `_${width}x${height}${extension}`,
  )
}
